import { render, staticRenderFns } from "./VehicleIcon.vue?vue&type=template&id=82cee3da&lang=pug&"
import script from "./VehicleIcon.vue?vue&type=script&lang=ts&"
export * from "./VehicleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports